import makePlaceholder from './Placeholder'

export default makePlaceholder({
  imageSet: {
    1: require('./images/error-icon.png'),
    2: require('./images/error-icon@2x.png'),
    3: require('./images/error-icon@3x.png'),
  },
})
